// extracted by mini-css-extract-plugin
var _1 = "ProgressTabContent__chapter--pl_BV";
var _2 = "ProgressTabContent__grade--VuK3A CoreGeneral__robotoSlab--X8lgW";
var _3 = "ProgressTabContent__gradeBars--OrbtM fontSize__profileText--q79uE";
var _4 = "ProgressTabContent__graph--HFfgI";
var _5 = "ProgressTabContent__labType--nRMOI ProgressTabContent__chapter--pl_BV";
var _6 = "ProgressTabContent__scrollBar--pAjDQ general__scrollBar--nOeLI";
var _7 = "ProgressTabContent__scrollThumb--iS0Sy general__scrollThumb--k3VcQ";
export { _1 as "chapter", _2 as "grade", _3 as "gradeBars", _4 as "graph", _5 as "labType", _6 as "scrollBar", _7 as "scrollThumb" }
